module.exports = __webpack_public_path__ + "img/hw.cffc82db.png";